import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcom-plain-header-area',
  templateUrl: './plain-header-area.component.html',
  standalone: false,
})
export class PlainHeaderAreaComponent {
  @Input()
  title: string;
  @Input()
  subtitle: string;
  @Input()
  headingClass = 'nordic-blue-900-text';
}
